import React from 'react'
import moreThanFiveYears from 'nove8/cohorts/woofz_rt/assets/images/sprite/moreThanFiveYears.svg'
import oneTwoYears from 'nove8/cohorts/woofz_rt/assets/images/sprite/oneTwoYears.svg'
import sevenTwelveMonths from 'nove8/cohorts/woofz_rt/assets/images/sprite/sevenTwelveMonths.svg'
import twoFiveYears from 'nove8/cohorts/woofz_rt/assets/images/sprite/twoFiveYears.svg'
import zeroSixMonths from 'nove8/cohorts/woofz_rt/assets/images/sprite/zeroSixMonths.svg'
import { DOG_AGE_STAGE_OPTIONS } from 'root-constants'

export type TOption = {
  value: string
  image: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
  translationKey: string
}

export const AGE_OPTIONS: Array<TOption> = [
  {
    value: DOG_AGE_STAGE_OPTIONS.YOUNGER_THEN_SIX_MONTH,
    image: zeroSixMonths,
    translationKey: 'onboarding.age.youngerThenSixMonth',
  },
  {
    value: DOG_AGE_STAGE_OPTIONS.SIX_TWELVE_MONTHS,
    image: sevenTwelveMonths,
    translationKey: 'onboarding.age.sixTwelveMonth',
  },
  {
    value: DOG_AGE_STAGE_OPTIONS.ONE_TWO_YEAR,
    image: oneTwoYears,
    translationKey: 'onboarding.age.oneTwoYear',
  },
  {
    value: DOG_AGE_STAGE_OPTIONS.TWO_SEVEN_YEARS,
    image: twoFiveYears,
    translationKey: 'onboarding.age.twoSevenYears',
  },
  {
    value: DOG_AGE_STAGE_OPTIONS.MORE_THAN_SEVEN_YEARS,
    image: moreThanFiveYears,
    translationKey: 'onboarding.age.moreThanSevenYears',
  },
]

export const NO_ANSWER = 'No'
export const QUESTION = 'Does your dog have free access to food all day?'
export const SCHEDULE_FEED_ANSWER = 'No, we feed on a schedule'
export const YES_ANSWER = 'Yes'
export const SOMETIMES_ANSWER = 'Sometimes'
export const NONE_ANSWER = 'none'
